import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TopBar from 'SharedComponents/TopBar/TopBar';
import SideBar from 'PreviewComponents/SideBar/SideBar';
import HeadlessContainer from 'PreviewComponents/HeadlessContainer/HeadlessContainer';
import ResponsiveContainer from 'PreviewComponents/ResponsiveContainer/ResponsiveContainer';
import PageContainer from 'PreviewComponents/PageContainer/PageContainer';
import { colourCanvas } from 'Styles/colors.css';
import styled from 'styled-components';
import MobileDetect from 'mobile-detect';
import { getMetadata, getAdId } from 'Selectors';

import {
  PRESENT,
  PREVIEW,
  APP,
  UI,
} from 'SharedConstants/';

import { HEADLESS_PREVIEW, SELECTED_CONTAINER } from 'PreviewConstants/';

const overflowHidden = 'overflow: hidden;';

const AppContainer = styled.div`
  background-color: ${colourCanvas};
  color: #626262;
  font-family: "Segoe UI", Arial, sans-serif;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0.01em;
  -webkit-font-smoothing: antialiased;
  width: 100%;
  height: 100%;
  ${props => !props.isDevice && overflowHidden}
`;

const FullscreenRevealPadding = styled.div`
  width: 100%;
  height: 50%;
  background-color: ${colourCanvas};
`;

const getIsDevice = () => {
  const { navigator: { userAgent } } = global.window;
  const mobileDetect = new MobileDetect(userAgent);
  return mobileDetect.phone();
};

class App extends PureComponent {
  constructor(props) {
    super(props);
    this.isDevice = getIsDevice() !== null;
  }
  componentDidMount() {
    const settingsPanel = document.getElementById('previewSettings');
    $(settingsPanel).portlet({ progress: 'bar', onRefresh: () => { $(settingsPanel).portlet({ }); } });
  }
  render() {
    const { isDevice } = this;
    const { headlessPreview, selectedContainer } = this.props;

    let Layout = PageContainer;

    if (selectedContainer === 'responsive') Layout = ResponsiveContainer;
    if (headlessPreview) Layout = HeadlessContainer;

    return (
      <AppContainer isDevice={isDevice}>
        { !headlessPreview && <TopBar /> }
        <Layout isDevice={isDevice} />
        { !isDevice && <SideBar /> }
      </AppContainer>
    );
  }
}

App.propTypes = {
  selectedContainer: PropTypes.string.isRequired,
  headlessPreview: PropTypes.bool.isRequired,
  revealFormat: PropTypes.bool,
  adId: PropTypes.number,
};

App.defaultProps = {
  selectedContainer: 'standard',
  revealFormat: false,
  maintainAspectRatio: false,
  adId: 0,
};

const mapStateToProps = state => ({
  selectedContainer: state.getIn([UI, SELECTED_CONTAINER]),
  headlessPreview: state.getIn([UI, HEADLESS_PREVIEW]),
  preview: state.getIn([APP, PRESENT, PREVIEW]),
  revealFormat: getMetadata(state).get('revealFormat') || getMetadata(state).get('formatName') === 'Scroller',
  maintainAspectRatio: getMetadata(state).get('maintainAspectRatio'),
  adId: getAdId(state),
});

export default connect(mapStateToProps, null)(App);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/App/App.jsx